import { render, staticRenderFns } from "./FooterBar.vue?vue&type=template&id=46075ac6&scoped=true&"
import script from "./FooterBar.vue?vue&type=script&lang=js&"
export * from "./FooterBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46075ac6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46075ac6')) {
      api.createRecord('46075ac6', component.options)
    } else {
      api.reload('46075ac6', component.options)
    }
    module.hot.accept("./FooterBar.vue?vue&type=template&id=46075ac6&scoped=true&", function () {
      api.rerender('46075ac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/FooterBar.vue"
export default component.exports